import { TextBox } from '@idexx-laboratories/spot-react';
import { runInAction } from 'mobx';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { useStore } from '../../hooks/use-store';

const guidRegex = /^([\dA-Fa-f]{8}-[\dA-Fa-f]{4}-[\dA-Fa-f]{4}-[\dA-Fa-f]{4}-[\dA-Fa-f]{12})$/;

const EnterHospitalIdModalContent = observer(() => {
  const { connectPracticeStore: store, globalModalStore } = useStore();
  const modalState = globalModalStore.globalModalState;

  useEffect(() => {
    runInAction(() => {
      store.hospitalId = '';
      if (!modalState.okDisabled) {
        modalState.okDisabled = true;
      }
    });
  }, [modalState, store]);

  useEffect(() => {
    runInAction(() => (modalState.okDisabled = !guidRegex.test(store.hospitalId)));
  }, [modalState, store.hospitalId]);

  return (
    <div className='enter-hospital-id-content_container'>
      <p>Please enter your practice&apos;s unique ID.</p>
      <TextBox
        placeholder='Enter your Trupanion Unique ID and click Submit'
        data-testid='hospital-id-textbox'
        value={store.hospitalId}
        onChange={e => runInAction(() => (store.hospitalId = e.target.value))}
      />
    </div>
  );
});

export default EnterHospitalIdModalContent;
